import { createLogic } from "redux-logic";
import * as ActionTypes from "../../actions/actionTypes";
import * as authActions from "../../actions/authActions";
import firebase from "firebase/app";
import "firebase/auth";

const trackAuthStatusLogic = createLogic({
	type: ActionTypes.TRACK_AUTH_STATUS,
	latest: true,
	warnTimeout: 0,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		firebase.auth().onAuthStateChanged(user => dispatch(authActions.authStatusChanged(user)));
	},
});

export default [trackAuthStatusLogic];
